import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import { useDispatch } from 'react-redux';
import { cn } from '@/utils/cn';
import {
  validatePass,
  validationResult,
} from '@/redux/reducers/help-request-reducer';
import Icon from '../Icon';
import TextXXSmall from '../Typography/TextXXSmall';
import TextSpan from '../Typography/TextSpan';

function TextAreaInput({
  label = '',
  iconName,
  value = '',
  className,
  name,
  placeholder = 'Enter your text',
  onChangeHandler,
  maxLength = 500,
  isRequired = false,
  rows = 4,
  validate = false,
  validationMessage = '',
}) {
  const dispatch = useDispatch();
  const [inputValue, setInputValue] = useState(value);
  const [error, setError] = useState('');
  // const [error, setError] = useState("Limit over");

  const handleInput = (e) => {
    const newValue = e.target.value;
    setInputValue(newValue);

    // Optional: Add custom validation if needed
    if (newValue.length > maxLength) {
      setError('Maximum character limit exceeded!');
    } else {
      setError('');
    }

    onChangeHandler(newValue);
  };

  useEffect(() => {
    if (validate) {
      if (inputValue?.length <= 0) {
        dispatch(validationResult({ invalid: true, name }));
        setError(validationMessage);
        return;
      }
      setError('');
      dispatch(validatePass({ name }));
    }
  }, [validate]);

  return (
    <div className={cn('textarea-with-label relative w-full', className)}>
      <div
        className={cn(
          'relative flex flex-row items-center justify-center pl-12 border border-senate rounded-[4px] overflow-hidden font-encode-sans gap-3 focus-within:border-2 active:border-2',
          {
            '!border-infrared-burn': error,
          },
        )}
      >
        {iconName ? (
          <div className="self-start mt-4">
            <Icon type={iconName} height="24px" width="24px" color="#5F6368" />
          </div>
        ) : null}
        <textarea
          name={name}
          rows={rows}
          className="text-gray-dark block w-full px-0 py-16 text-base focus:outline-none focus:ring-0 placeholder:text-senate placeholder:text-base placeholder:font-normal resize-none pr-12"
          maxLength={maxLength}
          placeholder={placeholder}
          onChange={handleInput}
          value={inputValue}
        />
        <TextXXSmall
          text={`${inputValue.length}/${maxLength}`}
          className="absolute bottom-2 right-3 text-xs lg:text-xs text-senate font-normal"
        />
      </div>
      <label
        className={classNames(
          'absolute top-[17px] font-encode-sans left-3 text-sm font-medium text-senate bg-white duration-300 transform -translate-y-6 px-[6px]',
          {
            '!text-infrared-burn': error,
          },
        )}
      >
        {label}
        {isRequired ? (
          <TextSpan
            text="*"
            className="text-sm lg:text-sm text-infrared-burn"
          />
        ) : null}
      </label>
      {error && (
        <TextSpan
          text={error}
          className="text-sm lg:text-sm text-infrared-burn font-medium leading-4 tracking-[0.24px] px-16"
        />
      )}
    </div>
  );
}

export default TextAreaInput;
